import { STORAGE } from "./storage";

export enum PlatformType {
  GPU,
  CPU,
  Picture,
  QY,
}
export enum PlatformStatus {
  Normal = 1,
  Busy,
  Full,
}

const getPlatformIdList = (key = "") => {
  return sessionStorage.getItem(key)
    ? JSON.parse(sessionStorage.getItem(key))
    : [];
};
export const PictureList = getPlatformIdList(STORAGE.PicturePlatforms);
export const CPUPlatformList = getPlatformIdList(STORAGE.CPUPlatforms);
export const GPUPlatformList = getPlatformIdList(STORAGE.GPUPlatforms);
export const QYPlatformList = getPlatformIdList(STORAGE.QYPlatforms);
